import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { LocalStorage } from 'src/app/appCommon/Enums/enum';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { StrokeQualityMetricervice } from 'src/app/appServices/ControlServices/stroke-quality-metrics';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { selectedFacilityOptionsImprove, spokeSiteOpions, timeFameList } from 'src/app/appWeb/shared/shared';
import { Workbook } from 'exceljs';
import * as FileSaver from 'file-saver'; // FOR SAVING EXCEL FILE
import { DatePipe } from '@angular/common';
// import * as $ from 'jquery';

@Component({
  selector: 'app-stroke-quality-metrics',
  templateUrl: './stroke-quality-metrics.component.html',
  styleUrls: ['./stroke-quality-metrics.component.scss']
})
export class StrokeQualityMetricsComponent implements OnInit {
  totalRecords = 0;
  pageNumber = 1;
  rows = 15;
  sortOrder = 'DESC';
  sortCol = '';
  filterVal = '';
  FileSaver = FileSaver;
  cols: any;

  showProgressSpinner: boolean = false;
  filterTypeErrorBool!: boolean;
  selectedFacilityOptions = selectedFacilityOptionsImprove;
  selectedFilterType: any;
  filterTypeBool: boolean = false;
  facilityQPSLbl: any;
  facilityErrorBool!: boolean;
  SelectListFilter: any = [];
  selectFacilityPIOptions: any;
  spokeSiteOpions = spokeSiteOpions;
  spokeSiteBool: boolean = false;
  spokeSite: any = '';
  event: any = '';
  SelectFacilityData: any = [];
  SelectSystemData: any = [];
  SelectRegionData: any = [];
  private subscription: Subscription[] = [];
  DateErrorBool : boolean = false;
  selectedDate: any = '';
  SearchLoader: boolean = false;

  timeFameList = timeFameList;
  timeFrame = 'Last48Hours';
  showDateBool: boolean = false;
  specificDatecolorBool:boolean = false;
  dateRangeBool: boolean = false;
  txtSpecificDate: any = '';
  showStartEndDateBool: boolean = false;
  textStrtColorBool:boolean = false;
  txtStartDate: any = '';
  txtEndDate: any = '';
  minDate = new Date();
  textEndColorBool:boolean = false;

  UId: any;
  RoleName: any;
  roleForFacility: boolean = false;
  txtSpecificDateErrorBool: boolean = false;
  txtStartDateErrorBool: boolean = false;
  txtEndDateErrorBool: boolean = false;
  data = {};
  strokeQualityMetricsData: any = [];
  exportExcelLoader: boolean = false;
  datePipe = new DatePipe('en-US');
  dataForExcelBool: boolean = false;
  crossSearchBool: boolean = false;

  constructor(private analyzeService: AnalyzeService,private helperService: HelperService, private authService: AuthService,
    private messageService: MessageService, private strokeQualityMetricervice: StrokeQualityMetricervice,
  private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.roleForFacility = this.authService.roleForFacility();
    this.minDate = this.analyzeService.CalanderDateRangeSelection(true);
  }

  onChangeFilterType(event: any) {
    this.event = event.value;
    if (event.value == this.selectedFacilityOptions[0].value) {
      this.SelectListFilter = '';
      this.SelectListFilter = this.SelectFacilityData;
      this.GetAllData(event.value);
      this.facilityQPSLbl = 1;
      this.filterTypeBool = true;
      this.spokeSiteBool = false;
    }
    if (event.value == this.selectedFacilityOptions[1].value) {
      this.SelectListFilter = '';
      this.SelectListFilter = this.SelectSystemData;
      this.GetAllData(event.value);
      this.facilityQPSLbl = 2;
      this.filterTypeBool = true;
      this.spokeSiteBool = true;
    }
    if (event.value == this.selectedFacilityOptions[2].value) {
      this.SelectListFilter = '';
      this.SelectListFilter = this.SelectRegionData;
      this.GetAllData(event.value);
      this.facilityQPSLbl = 3;
      this.filterTypeBool = true;
      this.spokeSiteBool = true;
    }
  }
  lazyLoadSchedules(event: any) {
    if (event != undefined) {
      this.rows = event.rows;
      this.pageNumber = event.first / this.rows + 1;
      this.sortOrder =
        event.multiSortMeta == undefined || event.multiSortMeta[0].order == -1
          ? 'DESC'
          : 'ASC';
      this.sortCol =
        event.multiSortMeta == undefined ? '' : event.multiSortMeta[0].field;

          this.GetStrokeQualityMetricsData('');

    }
  }

  onChangeTimeFrame(event: any) {
    if (event.value == this.timeFameList[10].value) {
      this.showStartEndDateBool = true;
    } else {
      this.showStartEndDateBool = false;
    }
    if (event.value == this.timeFameList[9].value) {
      this.showDateBool = true;
    } else {
      this.showDateBool = false;
    }
  }


  GetAllData(req: any) {
    if ((this.SelectFacilityData.length == 0 && req == 'facility') || 
    (this.SelectSystemData.length == 0 && req == 'system') ||
    (this.SelectRegionData.length == 0 && req == 'regional')) {
      // this.showProgressSpinner = true;
      let obj: any = {};
      if (req == 'facility') {
        obj.fieldName = 'facility';
        obj.value = 'facility';
      } else if(req == 'system') {
        obj.fieldName = 'ucd_ucl_key';
        obj.value = '42';
      }else{
        obj.fieldName = 'ucd_ucl_key';
        obj.value = '43';
    }
      this.subscription.push(
        this.analyzeService.GetAllData(obj, this.RoleName, this.UId).subscribe({
          next: (res: any) => {
            if (res) {
              // this.showProgressSpinner = false;
              if (req == 'facility') {
                this.SelectFacilityData = res.data;
                this.SelectListFilter = res.data;
              } else if(req == 'system') {
                this.SelectSystemData = res.data;
                this.SelectListFilter = res.data;
              }else{
                this.SelectRegionData = res.data;
                this.SelectListFilter = res.data;
              }
            }
          },
          error: (err: any) => { },
        })
      );
    }
  }

  checkEmptyFields(type:string) {
      if(this.timeFrame === '-1'){
        this.txtEndDate = new Date().toDateString();
        this.txtStartDate = this.analyzeService.CalanderDateRangeSelection(true).toDateString();
      }
      this.data = {
        Take: type == 'grid' ? this.rows : 0,
        Skip: type == 'grid' ? this.rows * this.pageNumber - this.rows : 0,
        Sort: {
          FieldName: this.sortCol,
          Order: this.sortOrder,
        },
        // searchString: this.searchField.trim(),
        PageNumber: this.pageNumber,
        serviceType: [],
        roleIDs: [''],
        Filters: [

          {
            FieldName: 'date_filter',
            value: this.timeFrame  == '-1' ? 'DateRange' : this.timeFrame
          },
          {
            FieldName: 'specific_date',
            value: this.txtSpecificDate,
          },
          {
            FieldName: 'start_date',
            value: this.txtStartDate,
          },
          {
            FieldName: 'end_date',
            value: this.txtEndDate,
          },
        ],
        data: {
          Facilities: this.selectedFilterType == 'facility' ? [this.selectFacilityPIOptions]: [],
          System: this.selectedFilterType == 'system' ? [this.selectFacilityPIOptions]: [],
          Regional: this.selectedFilterType == 'regional' ? [this.selectFacilityPIOptions]: [],
          FilterType: this.selectedFilterType,
          SpokeSiteFilter: this.spokeSite
        }
      };
      if(type == 'grid'){
      if(this.timeFrame == "DateRange"){
        if(this.txtStartDate == null || this.txtStartDate == ''){
          this.txtStartDateErrorBool = true;
        }else{
          this.txtStartDateErrorBool = false;
        }
        if(this.txtEndDate == null || this.txtEndDate == ''){
          this.txtEndDateErrorBool = true;
        }else{
          this.txtEndDateErrorBool = false;
        }
        if(this.txtStartDate != null && this.txtEndDate != null && this.txtEndDate !== '' && this.txtStartDate !== ''){
          let txtStartDate = new Date(this.txtStartDate);
          let txtEndDate = new Date(this.txtEndDate);
          if(txtStartDate > txtEndDate){
            this.dateRangeBool = true;
          }else{
            this.dateRangeBool = false;
          }
        }
      }else{
        this.txtStartDateErrorBool = false;
        this.txtEndDateErrorBool = false;
        this.dateRangeBool = false;
      } 
      
      if(this.timeFrame == "SpecificDate"){
        if(this.txtSpecificDate == null || this.txtSpecificDate == ''){
          this.txtSpecificDateErrorBool = true;
        }else{
          this.txtSpecificDateErrorBool = false;
        }
      }else{
        this.txtSpecificDateErrorBool = false;
      }
    }
    
  }

  GetStrokeQualityMetricsData(type:string){
   this.checkEmptyFields('grid');

    if (this.selectedFilterType != null && this.selectFacilityPIOptions != null && this.timeFrame !== 'SpecificDate' && this.timeFrame !== 'DateRange' ||
    this.selectedFilterType != null && this.selectFacilityPIOptions != null && this.timeFrame == 'SpecificDate' && this.txtSpecificDateErrorBool == false ||
    this.selectedFilterType != null && this.selectFacilityPIOptions != null && this.timeFrame == 'DateRange' && this.txtStartDateErrorBool == false && this.txtEndDateErrorBool == false && 
    this.dateRangeBool == false) {
    this.showProgressSpinner = true;
    this.dataForExcelBool = false;
    this.subscription.push(
      this.strokeQualityMetricervice.GetStrokeQualityMetricCases(this.UId, this.RoleName, this.data).subscribe({
        next: (res: any) => {
        this.strokeQualityMetricsData = [];
          if(res.data?.length > 0){
            this.dataForExcelBool = true;
            this.strokeQualityMetricsData = res.data;
            this.strokeQualityMetricsData.forEach((val:any) =>{
              if(val.CaseWorkflowTitles){
                val.CaseWorkflowTitles = val.CaseWorkflowTitles.split(',').map((item:any) => item.trim()).filter((item: string) => item !== "Not Applicable");
              }
            })
          }

          this.showProgressSpinner = false;
          this.totalRecords = res.Total;
        },
        error: (err: any) => { },
      })
    );
    }else{
      if (this.selectedFilterType == null && type === 'click') {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Plese select Filter Type first.',
        });
        this.filterTypeErrorBool = true;
        setTimeout(() => {
          this.filterTypeErrorBool = false;
        }, 1000);
        return;
      }

      if (this.selectFacilityPIOptions == null && type === 'click') {
        let facilitysystem: any;
        if (this.event == 'facility') {
          facilitysystem = 'Facility';
        } else if(this.event == 'system')  {
          facilitysystem = 'System';
        } else  {
          facilitysystem = 'Regional';
        }
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: `Plese select ${facilitysystem} first.`,
        });
        this.facilityErrorBool = true;
        setTimeout(() => {
          this.facilityErrorBool = false;
        }, 1000);
        return;
      }

      if (this.selectFacilityPIOptions == null && type === 'click') {
        let monthquarter: any;
        if (this.event == 'facility') {
          monthquarter = 'Month'
        } else {
          monthquarter = 'Quarter'
        }
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: `Plese select ${monthquarter} first.`,
        });
        this.facilityErrorBool = true;
        setTimeout(() => {
          this.facilityErrorBool = false;
        }, 1000);
        return;
      }
      if(this.txtSpecificDateErrorBool == true && type === 'click'){
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Please select Date first.',
        });
        this.specificDatecolorBool = true;
        setTimeout(() => {
        this.specificDatecolorBool = false;
        }, 1000);
        return;
      }
      if(this.txtStartDateErrorBool == true && type === 'click'){
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Please select Start Date first.',
        });
        this.textStrtColorBool = true;
        setTimeout(() => {
        this.textStrtColorBool = false;
        }, 1000);
        return;
      }
      if(this.txtEndDateErrorBool == true && type === 'click'){
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'Please select End Date first.',
        });
        this.textEndColorBool = true;
        setTimeout(() => {
        this.textEndColorBool = false;
        }, 1000);
        return;
      }
      if(this.dateRangeBool == true && type === 'click'){
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'End Date should be greater than Start Date.',
        });
        // this.textStrtColorBool = true;
        this.textEndColorBool = true;
        setTimeout(() => {
          // this.textStrtColorBool = false;
          this.textEndColorBool = false;
        }, 1000);
        return;
      }
    }
  }

  excelDownload(workbook: any, fileName: any) {
    workbook.xlsx.writeBuffer().then((data: any) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, fileName + '.xlsx');
    })
  }

  exportExcel() {
    this.exportExcelLoader = true;
    let newArray: any = [];
    let strokeQualityMetricsData: any = [];

    this.checkEmptyFields('excel');
    this.subscription.push(
      this.strokeQualityMetricervice.GetStrokeQualityMetricCases(this.UId, this.RoleName, this.data).subscribe({
        next: (res: any) => {
          if(res.data?.length > 0){
            this.dataForExcelBool = true;
            strokeQualityMetricsData = res.data;
            strokeQualityMetricsData.forEach((val:any) =>{
              if(val.CaseWorkflowTitles){
                val.CaseWorkflowTitles = val.CaseWorkflowTitles.split(',').map((item:any) => item.trim()).filter((item: string) => item !== "Not Applicable");
              }
            })
          }

        if (strokeQualityMetricsData.length > 0) {
            strokeQualityMetricsData.filter((obj:any) => {
              for (const key in obj) {
                if (typeof obj[key] === 'string' && !isNaN(Date.parse(obj[key]))) {
                  obj[key] = this.datePipe.transform(obj[key],'MM/dd/yyyy HH:mm:ss');
                  
                }
              }
              if(obj.cas_billing_dob){
                obj.cas_billing_dob = this.datePipe.transform(new Date(obj.cas_billing_dob),'MM/dd/yyyy');
              }
              if(obj.cas_billing_date_of_consult){
                obj.cas_billing_date_of_consult = this.datePipe.transform(new Date(obj.cas_billing_date_of_consult),'MM/dd/yyyy');
              }
              const caseWorkflowTitles = obj.CaseWorkflowTitles ? obj.CaseWorkflowTitles.filter((title:any) =>title && title !== 'Not Applicable').map((val:any) => `\u2022 ${val}`).join('\n') : '';
              // obj.CaseWorkflowTitles = obj.CaseWorkflowTitles.split(',').map((item: string) => item.trim()).filter((item: string) => item !== "Not Applicable");
              newArray.push({cas_billing_date_of_consult: obj.cas_billing_date_of_consult,
                cas_case_number: obj.cas_case_number,
                cas_metric_tpa_consult: obj.cas_metric_tpa_consult == true ? 'Yes' : 'No',
                fac_name: obj.fac_name,
                cas_patient: obj.cas_patient,
                cas_billing_dob: obj.cas_billing_dob,
                cas_response_ts_notification: obj.cas_response_ts_notification,
                PhysicianName:obj.PhysicianName,
                CaseType: obj.CaseType ,
                PatientIdentifier: obj.PatientIdentifier,
                WorkflowType: obj.WorkflowType == 1 ? 'EMS' : obj.WorkflowType == 2 ? 'Inpatient' : obj.WorkflowType == 3 ? 'Triage/Walk-In' : obj.WorkflowType == 4 ? 'Symptom Onset During ED Stay' : '',
                cas_metric_lastwell_date_est: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.cas_metric_lastwell_date_est : '',
                cas_is_ealert: obj.cas_is_ealert == true ? 'Yes' : 'No',
                cas_metric_door_time_est: obj.cas_metric_door_time_est,
                cas_metric_stamp_time_est: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.cas_metric_stamp_time_est : '',
                cas_metric_initial_response_time_est: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.cas_metric_initial_response_time_est : '',
                cas_assessment_time_est: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.cas_assessment_time_est : '',
                start_to_needle_time: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.start_to_needle_time : '',
                arrival_to_needle_time: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.arrival_to_needle_time : '',
                cas_response_thrombolytic: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? (obj.cas_response_thrombolytic == true ? 'Yes' : 'No') : '' ,
                activation_to_starttime: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.activation_to_starttime : '',
                assessment_to_starttime: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.assessment_to_starttime : '',
                thrombolytic_to_starttime: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.thrombolytic_to_starttime : '',
                needle_to_thrombolytic: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.needle_to_thrombolytic : '',
                cas_metric_alteplase_medical_decision: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.cas_metric_alteplase_medical_decision : '',
                cas_metric_needle_time_est: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.cas_metric_needle_time_est : '',
                ctai_lvo: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? (obj.ctai_lvo  == true ? 'Yes' : 'No') : '',
                ThrombolyticUsed: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.ThrombolyticUsed : '',
                cas_metric_has_morbid_symptoms: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.cas_metric_has_morbid_symptoms : '',
                ctai_discussed_with_nir: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? (obj.ctai_discussed_with_nir  == true ? 'Yes' : 'No') : '',
                ctai_nir_discussion_time: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.ctai_nir_discussion_time : '',
                ctai_initial_call_time_to_nir: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.ctai_initial_call_time_to_nir : '',
                CaseWorkflowTitles: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? caseWorkflowTitles : '',
                cas_is_audio_consult: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? (obj.cas_is_audio_consult == true ? 'Yes' : 'No') : '',
                cas_nihss_totalscore: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' || obj.CaseType === 'Routine Consult- New' ? obj.cas_nihss_totalscore : '',
                cas_nihss_cannot_completed: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' || obj.CaseType === 'Routine Consult- New' ? (obj.cas_nihss_cannot_completed == true ? 'Yes' : 'No') : '',
                cas_nihss_reason: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' || obj.CaseType === 'Routine Consult- New' ? 
                (obj.cas_NIHSS_comatose == 1 ? 'Patient is comatose' :
                obj.cas_NIHSS_comatose == 2 ? 'Patient was intubated and paralyzed' :
                obj.cas_NIHSS_comatose == 3 ? 'Other: ' + obj.cas_NIHSS_comatose_text : '') : '',
                cas_metric_symptoms: obj.CaseType === 'Stroke Alert' || obj.CaseType === 'STAT Consult' ? obj.cas_metric_symptoms : ''});

            });

          let dataForExcel: any = [];
          let workbook = new Workbook();
          let worksheet = workbook.addWorksheet('Sheet1', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
          worksheet.columns = [
            { header: 'Date of Consult', key: 'Date of Consult', width: 25 },
            { header: 'Case No.', key: 'Case No.', width: 20 },
            { header: 'Lytic Status', key: 'Lytic Status', width: 20 },
            { header: 'Facility', key: 'Facility', width: 70 },
            { header: 'Patient Name', key: 'Patient Name', width: 25 },
            { header: 'Patient DOB', key: 'Patient DOB ', width: 25 },
            { header: 'Start Time', key: 'Start Time', width: 20 },
            { header: 'Phyician', key: 'Phyician', width: 20 },
            { header: 'Case Type', key: 'Case Type', width: 25 },
            { header: 'Patient Identifier', key: 'Patient Identifier', width: 25 },
            { header: 'Workflow Type', key: 'Workflow Type', width: 25 },
            { header: 'Last Known Well', key: 'Last Known Well', width: 25 },
            { header: 'E-Alert', key: 'E-Alert', width: 15 },
            { header: 'Arrival Time', key: 'Arrival Time', width: 25 },
            { header: 'Stamp Time', key: 'Stamp Time', width: 25 },
            { header: 'Initial Reponse Time', key: 'Initial Reponse Time', width: 25 },
            { header: 'Assessment Time', key: 'Assessment Time', width: 25 },
            { header: 'Start Time to Needle Time', key: 'Start Time to Needle Time', width: 25 },
            { header: 'Arrival to Needle Time', key: 'Arrival to Needle Time', width: 25 },
            { header: 'Thrombolytic-related Complication', key: 'Thrombolytic-related Complication', width: 30 },
            { header: 'Activation Time Interval Metric', key: 'Activation Time Interval Metric', width: 30 },
            { header: 'Assessment Time Interval Metric', key: 'Assessment Time Interval Metric', width: 25 },
            { header: 'Thrombolytic Decision Interval Metric', key: 'Thrombolytic Decision Interval Metric', width: 35 },
            { header: 'Thrombolytic Administration Interval Metric', key: 'Thrombolytic Administration Interval Metric', width: 35 },
            { header: 'Thrombolytic Medical Decision Time', key: 'Thrombolytic Medical Decision Time', width: 30 },
            { header: 'Needle Time', key: 'Needle Time', width: 25 },
            { header: 'LVO', key: 'LVO', width: 15 },
            { header: 'Thrombolytic Used', key: 'Thrombolytic Used', width: 25 },
            { header: 'Pre-Morbid MRS', key: 'Pre-Morbid MRS', width: 25 },
            { header: 'Discussed with NIR', key: 'Discussed with NIR', width: 25 },
            { header: 'Discussed with NIR Time', key: 'Discussed with NIR Time', width: 25 },
            { header: 'Initial Response Time to Discussed with NIR', key: 'Initial Response Time to Discussed with NIR', width: 35 },
            { header: 'RCA-Tertiary Causes', key: 'RCA-Tertiary Causes', width: 70 },
            { header: 'Audio Only', key: 'Audio Only', width: 20 },
            { header: 'NIHSS', key: 'NIHSS', width: 15 },
            { header: 'NIHSS may not be reliable due to', key: 'NIHSS may not be reliable due to', width: 35 },
            { header: 'NIHSS may not be reliable due to- reason', key: 'NIHSS may not be reliable due to- reason', width: 35 },
            { header: 'Symptoms', key: 'Symptoms', width: 40 },
          ]
          worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell((cell, number) => {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '767C88' },
                bgColor: { argb: '' },
    
              }
              cell.font = {
                bold: true,
                color: { argb: 'FFFFFF' },
                size: 12,
              }
            //   if (worksheet.getColumn(number).key === 'CaseWorkflowTitles') {
            //     cell.alignment = { wrapText: true };
            // }
            })
          })
          newArray.forEach((element: any) => {
            dataForExcel.push(Object.values(element))
          });
    
          dataForExcel.forEach((d: any) => {
            d.CaseWorkflowTitles = d.CaseWorkflowTitles ? d.CaseWorkflowTitles.join('\n') : d.CaseWorkflowTitles;
            let row = worksheet.addRow(d);
          })
          worksheet.getColumn('RCA-Tertiary Causes').alignment = { wrapText: true };
          this.excelDownload(workbook, "Stroke Quality Metrics");
          this.exportExcelLoader = false;
        }
      },
      error: (err: any) => { },
    })
  );
    
  }

}
